import React, { useEffect, useState, useMemo } from 'react';
import { Calendar } from "@amir04lm26/react-modern-calendar-date-picker";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export const FixedCalendarPopup = () => {
  const [value, setInitialValue] = useState(new Date());
  const [title, setTitle] = useState('');
  const [calendarFunction, setCalendarFunction] = useState<(date: Date) => void>(() => { });
  const [show, setShow] = useState(false);
  const closeModal = () => {
    setShow(false);
  }

  const setValue = useMemo(() => {
    return (date) => {
      setInitialValue(new Date(date.year, date.month - 1, date.day));
      calendarFunction(new Date(date.year, date.month - 1, date.day));
    }
  }, [calendarFunction])
  const formattedValue = {
    year: value.getFullYear(),
    month: value.getMonth() + 1,
    day: value.getDate()
  }

  useEffect(() => {
    (window as any).setUpCalendar = (title: string, calendarFunction: (date: Date) => void, value: Date) => {
      // check if value is a valid date or the dec 31 1969 date
      if (value.toString() === "Invalid Date" || (value.getFullYear() === 1969 && value.getMonth() === 11 && value.getDate() === 31)) {
        value = new Date()
      }
      setTitle(title);
      setCalendarFunction(calendarFunction);
      setInitialValue(value);
      setShow(true);
    }
    (window as any).closeCalendar = () => {
      setShow(false);
    }
  }, [calendarFunction, value, title, show])

  return (
    <div id='fixed-calendar-shadow' style={{
      display: show ? 'block' : 'none',
    }} className='shadow' onClick={(event) => {
      // if anything but the calendar is clicked, close the calendar
      if (event.target?.id === "fixed-calendar-shadow") {
        closeModal();
      }
    }}>
      <div id="fixed-calendar-popup" className='d-flex flex-column'>
        <div className='d-flex flex-row justify-content-between'>
          {title && <h4 className='flex-fill'>{title}</h4>}
          <div onClick={() => closeModal()} className='px-2'><FontAwesomeIcon size='xl' icon={faTimes} /></div>
        </div>
        <Calendar
          value={formattedValue}
          onChange={(date) => { setValue(date) }}
        />
      </div>
    </div>
  )
}